import React from 'react';
import { APITypes } from '../../../../primary-record-types';
import useNotes from '../../../../hooks/api/useNotes';
import CommentList from '../../CommentList/CommentList';
import CommentItem from '../../CommentList/CommentItem';
import urls from '../../../../utils/urls';

export type NoteCommentsListOwnProps = {
    note: APITypes.notesService.NoteDetails;
};

export type NoteCommentsListProps = NoteCommentsListOwnProps;

const NoteCommentsList: React.FC<NoteCommentsListProps> = ({ note }) => {
    const { comment, isCommenting } = useNotes({
        noteId: note.noteId,
    });

    return (
        <CommentList
            comments={note.comments}
            getCommentId={(comment) => comment.noteCommentId}
            renderComment={(comment) => {
                // A copied comment on a client-record copy carries its author's name as it was when copied and
                // resolves no account, so the label stands in for the name and its initials for the photo.
                const [labelFirstName, ...labelRest] = (comment.createdBySourceLabel ?? '').split(' ');
                return (
                    <CommentItem
                        key={comment.noteCommentId}
                        comment={comment.comment}
                        firstName={comment.createdBy?.firstName || labelFirstName || null}
                        preferredName={comment.createdBy?.preferredName || null}
                        lastName={comment.createdBy?.lastName || labelRest.join(' ') || null}
                        createdAt={comment.createdAt}
                        avatarAPIUrl={
                            comment.createdBy?.userId
                                ? urls.api.notes.noteUserAvatar(note.noteId, comment.createdBy?.userId)
                                : null
                        }
                    />
                );
            }}
            isSubmittingComment={isCommenting}
            onCommentSubmit={(commentText: string) => {
                comment({
                    noteId: note.noteId,
                    comment: commentText,
                });
            }}
        />
    );
};

export default React.memo(NoteCommentsList);
